module.exports = __webpack_public_path__ + "img/foto-programas.ca645418.png";